export default __webpack_public_path__ + "static/media/speakruss_logo.5ac29cc6.jpeg";